import request from '@/utils/request';

//上传文件到腾讯云cos
export const uploadToCos = params => {
    return request({
        url: '/upload/uploadToCos',
        method: 'post',
        data:params
    });
};
//上传文件到阿里云oss
export const uploadToOss = params => {
    return request({
        url: '/upload/uploadToOss',
        method: 'post',
        data:params
    });
};
//上传文件本地
export const uploadToLocal = params => {
    return request({
        url: '/upload/uploadToLocal',
        method: 'post',
        data:params
    });
};
//附件详情
export const fileLook = id => {
    return request({
        url: `/eduAnnex/info/${id}`,
        method: 'get',
    });
};
//通过ID下载文件
export const downloadFile = id => {
    return request({
        url: `/upload/download?id=${id}&openStyle=1`,
        method: 'get',
				responseType:'blob',
    });
};

//获取未处理审核数量
export const getReviewNum = projectId => {
    return request({
        url: `/api/eduSubjectDeclare/count/${projectId}`,
        method: 'get',
    });
};

//课题管理二级获取未处理审核数量
export const getReviewNumOnTopicManage = () => {
    return request({
        url: `/api/eduProjectManagement/count`,
        method: 'get',
    });
};

//判断当前用户是否是普通教师且有在研课题！
export const isTeacherAndHaveLesson = () => {
    return request({
        url: `/api/eduProjectManagement/teacherJump`,
        method: 'get',
    });
};
//待审核统计
export const projectNum = params => {
    return request({
        url: '/index/project/num',
        method: 'post',
        data:params
    });
};

